export default "__VITE_ASSET__8086dfee__"